import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_QUIZZES, res.data)
  })
)

export const show = async ({ commit }, params) => {
  await services.find(params).then(res => {
    commit(types.SET_QUIZ, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_QUIZ, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  if (obj.room_id) {
    await services.orderList(obj).then(res => {
      commit(types.SET_QUIZZES, res.data)
      return res.data
    })
  }
}

export const deleteQuiz = async ({ commit }, obj) => {
  await services.deleteQuiz(obj).then(res => {
    return res
  })
}

export const deleteAnswer = async ({ commit }, obj) => {
  await services.deleteAnswer(obj).then(res => {
    return res
  })
}
